import { LibraryIcon } from './LibraryIcon';

/**
 * author: Google
 * id 45FA5A9C-DFF1-4D7E-B683-DB7DE2BAEFC7
 * name library
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/library.svg
 * tags
 * - Places 
 */
export const LocalLibraryIcon = LibraryIcon;
export default LocalLibraryIcon